export const mageIconOptions = [
  { value: 'mage:notification-bell', label: 'bell' },
  { value: 'mage:book-text', label: 'book' },
  { value: 'mage:building-a', label: 'home' },
  { value: 'mdi:calendar-month-outline', label: 'calendar' },
  { value: 'mage:chart-vertical', label: 'bar-chart-2' },
  { value: 'mage:checklist-note', label: 'check-square' },
  { value: 'mage:clipboard-2', label: 'clipboard' },
  { value: 'mage:clock', label: 'clock' },
  { value: 'mage:delivery-truck', label: 'truck' },
  { value: 'mage:file', label: 'file' },
  { value: 'mage:file-download-fill', label: 'download' },
  { value: 'mage:email', label: 'mail' },
  { value: 'mage:external-link', label: 'external-link' },
  { value: 'mage:dollar', label: 'credit-card' },
  { value: 'mage:flag', label: 'flag' },
  { value: 'mage:folder-open', label: 'folder' },
  { value: 'mage:health-circle', label: 'heart' },
  { value: 'mage:home-3', label: 'home' },
  { value: 'mage:information-circle', label: 'info' },
  { value: 'mage:key', label: 'key' },
  { value: 'mage:location-pin', label: 'location-pin' },
  { value: 'mage:lock', label: 'lock' },
  { value: 'mage:message', label: 'message' },
  { value: 'mage:note', label: 'note' },
  { value: 'mage:phone', label: 'phone' },
  { value: 'mage:question-mark-circle', label: 'question' },
  { value: 'mage:shopping-cart', label: 'shopping-cart' },
  { value: 'mage:star', label: 'star' },
  { value: 'mage:file-upload-fill', label: 'upload' },
  { value: 'mage:user', label: 'user' },
  { value: 'mage:users', label: 'users' },
  { value: 'mage:exclamation-triangle', label: 'alert-triangle' },
  { value: 'mdi:cog-outline', label: 'settings'}
];

export const getMageIconLabel = (value) =>
  mageIconOptions.find((option) => option.value === value)?.label || '';
